import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import useMileageOptionsLogic from "./useMileageOptionsLogic";

const columns = [
  { field: "name", label: "Name", allowSorting: true },
  { field: "daily_km_limit", label: "Daily km limit", allowSorting: true },
  {
    field: "extrakm_rate_ratio",
    label: "Daily rate multiplier",
    allowSorting: true,
  },
];

const MileageOptionsPage = () => {
  const { addRoles, deleteRoles, editRoles, initFields, apiRoute } =
    useMileageOptionsLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta
          name="description"
          content="Welcome to the Mileage Options Page."
        />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="mileage_option"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
      />
    </div>
  );
};

export default MileageOptionsPage;
